import type { PiletApi } from '@chess/platform-web';
import { CHESS_API, type Chess } from '@chess/api-chess';
import { MOTIFS_API, type Motifs } from '@chess/api-mistakes';
import { classifyMotif } from './classify.ts';
import { referencesFor } from './references.ts';

// The motif provider: the `mistakes.motifs` API, one motif (family and
// variation) for one blunder or miss, read from the positions and the
// engine's lines the fact carries, and the pages to learn it from
// (`references.ts` over `references.json`). The identification is the pure
// modules beside this file (`classify.ts` and one detector per family); the
// scheme and the contract are `@chess/api-mistakes`'. Registered once the
// rules of chess (`chess`) are at hand, for a trapped piece's escapes and a
// mate at the end of a line. Readers: the store (the `motif` keys of the
// library's `mistake` filter), the Blunders and Misses screens, the library
// filter's chips, the puzzles' card, banner and Learn card.
export function setup(app: PiletApi) {
  app.getApi<Chess>(CHESS_API).then((chess) => {
    const motifs: Motifs = { classify: (input) => classifyMotif(input, chess), referencesFor: (motif) => referencesFor(motif) };
    app.registerApi(MOTIFS_API, motifs);
  });
}
